import React, { ComponentProps, PropsWithChildren } from 'react'

import dynamic from 'next/dynamic'
import { IconComponent, ImgIconComponent, SvgIconComponent } from './CreditUnionIcon/iconComponentType'
import analytics from './CreditUnionIcon/icons/analytics.svg'
import analyticsLine from './CreditUnionIcon/icons/analytics-line.svg'
import analyticsDuotone from './CreditUnionIcon/icons/analytics-duotone.svg'
import analyticsMonotone from './CreditUnionIcon/icons/analytics-monotone.svg'
import australiaLine from './CreditUnionIcon/icons/australia-line.svg'
import australiaDuotone from './CreditUnionIcon/icons/australia-duotone.svg'
import australiaMonotone from './CreditUnionIcon/icons/australia-monotone.svg'
import blankmonitorLine from './CreditUnionIcon/icons/blankmonitor-line.svg'
import blankmonitorDuotone from './CreditUnionIcon/icons/blankmonitor-duotone.svg'
import blankmonitorMonotone from './CreditUnionIcon/icons/blankmonitor-monotone.svg'
import calculatorLine from './CreditUnionIcon/icons/calculator-line.svg'
import calculatorDuotone from './CreditUnionIcon/icons/calculator-duotone.svg'
import calculatorMonotone from './CreditUnionIcon/icons/calculator-monotone.svg'
import calendarLine from './CreditUnionIcon/icons/calendar-line.svg'
import calendarDuotone from './CreditUnionIcon/icons/calendar-duotone.svg'
import calendarMonotone from './CreditUnionIcon/icons/calendar-monotone.svg'
import carLine from './CreditUnionIcon/icons/car-line.svg'
import carDuotone from './CreditUnionIcon/icons/car-duotone.svg'
import carMonotone from './CreditUnionIcon/icons/car-monotone.svg'
import caravanLine from './CreditUnionIcon/icons/caravan-line.svg'
import caravanDuotone from './CreditUnionIcon/icons/caravan-duotone.svg'
import caravanMonotone from './CreditUnionIcon/icons/caravan-monotone.svg'
import visacardLine from './CreditUnionIcon/icons/visacard-line.svg'
import visacardDuotone from './CreditUnionIcon/icons/visacard-duotone.svg'
import visacardMonotone from './CreditUnionIcon/icons/visacard-monotone.svg'
import chatLine from './CreditUnionIcon/icons/chat-line.svg'
import chatDuotone from './CreditUnionIcon/icons/chat-duotone.svg'
import chatMonotone from './CreditUnionIcon/icons/chat-monotone.svg'
import circlestarLine from './CreditUnionIcon/icons/circlestar-line.svg'
import circlestarDuotone from './CreditUnionIcon/icons/circlestar-duotone.svg'
import circlestarMonotone from './CreditUnionIcon/icons/circlestar-monotone.svg'
import clockLine from './CreditUnionIcon/icons/clock-line.svg'
import clockDuotone from './CreditUnionIcon/icons/clock-duotone.svg'
import clockMonotone from './CreditUnionIcon/icons/clock-monotone.svg'
import contactLine from './CreditUnionIcon/icons/contact-line.svg'
import contactDuotone from './CreditUnionIcon/icons/contact-duotone.svg'
import contactMonotone from './CreditUnionIcon/icons/contact-monotone.svg'
import documentLine from './CreditUnionIcon/icons/document-line.svg'
import documentDuotone from './CreditUnionIcon/icons/document-duotone.svg'
import documentMonotone from './CreditUnionIcon/icons/document-monotone.svg'
import dollarLine from './CreditUnionIcon/icons/dollar-line.svg'
import dollarDuotone from './CreditUnionIcon/icons/dollar-duotone.svg'
import dollarMonotone from './CreditUnionIcon/icons/dollar-monotone.svg'
import downLine from './CreditUnionIcon/icons/down-line.svg'
import downDuotone from './CreditUnionIcon/icons/down-duotone.svg'
import downMonotone from './CreditUnionIcon/icons/down-monotone.svg'
import envelopeLine from './CreditUnionIcon/icons/envelope-line.svg'
import envelopeDuotone from './CreditUnionIcon/icons/envelope-duotone.svg'
import envelopeMonotone from './CreditUnionIcon/icons/envelope-monotone.svg'
import findusLine from './CreditUnionIcon/icons/findus-line.svg'
import findusDuotone from './CreditUnionIcon/icons/findus-duotone.svg'
import findusMonotone from './CreditUnionIcon/icons/findus-monotone.svg'
import mobilelocationLine from './CreditUnionIcon/icons/mobilelocation-line.svg'
import mobilelocationDuotone from './CreditUnionIcon/icons/mobilelocation-duotone.svg'
import mobilelocationMonotone from './CreditUnionIcon/icons/mobilelocation-monotone.svg'
import handLine from './CreditUnionIcon/icons/hand-line.svg'
import handDuotone from './CreditUnionIcon/icons/hand-duotone.svg'
import handMonotone from './CreditUnionIcon/icons/hand-monotone.svg'
import headphonesLine from './CreditUnionIcon/icons/headphones-line.svg'
import headphonesDuotone from './CreditUnionIcon/icons/headphones-duotone.svg'
import headphonesMonotone from './CreditUnionIcon/icons/headphones-monotone.svg'
import homeLine from './CreditUnionIcon/icons/home-line.svg'
import homeDuotone from './CreditUnionIcon/icons/home-duotone.svg'
import homeMonotone from './CreditUnionIcon/icons/home-monotone.svg'
import investLine from './CreditUnionIcon/icons/invest-line.svg'
import investDuotone from './CreditUnionIcon/icons/invest-duotone.svg'
import investMonotone from './CreditUnionIcon/icons/invest-monotone.svg'
import lockLine from './CreditUnionIcon/icons/lock-line.svg'
import lockDuotone from './CreditUnionIcon/icons/lock-duotone.svg'
import lockMonotone from './CreditUnionIcon/icons/lock-monotone.svg'
import mobilelendingLine from './CreditUnionIcon/icons/mobilelending-line.svg'
import mobilelendingDuotone from './CreditUnionIcon/icons/mobilelending-duotone.svg'
import mobilelendingMonotone from './CreditUnionIcon/icons/mobilelending-monotone.svg'
import moneyLine from './CreditUnionIcon/icons/money-line.svg'
import moneyDuotone from './CreditUnionIcon/icons/money-duotone.svg'
import moneyMonotone from './CreditUnionIcon/icons/money-monotone.svg'
import monitorLine from './CreditUnionIcon/icons/monitor-line.svg'
import monitorDuotone from './CreditUnionIcon/icons/monitor-duotone.svg'
import monitorMonotone from './CreditUnionIcon/icons/monitor-monotone.svg'
import shieldLine from './CreditUnionIcon/icons/shield-line.svg'
import shieldDuotone from './CreditUnionIcon/icons/shield-duotone.svg'
import shieldMonotone from './CreditUnionIcon/icons/shield-monotone.svg'
import freechargeLine from './CreditUnionIcon/icons/freecharge-line.svg'
import freechargeDuotone from './CreditUnionIcon/icons/freecharge-duotone.svg'
import freechargeMonotone from './CreditUnionIcon/icons/freecharge-monotone.svg'
import percentageLine from './CreditUnionIcon/icons/percentage-line.svg'
import percentageDuotone from './CreditUnionIcon/icons/percentage-duotone.svg'
import percentageMonotone from './CreditUnionIcon/icons/percentage-monotone.svg'
import piggyLine from './CreditUnionIcon/icons/piggy-line.svg'
import piggyDuotone from './CreditUnionIcon/icons/piggy-duotone.svg'
import piggyMonotone from './CreditUnionIcon/icons/piggy-monotone.svg'
import profileLine from './CreditUnionIcon/icons/profile-line.svg'
import profileDuotone from './CreditUnionIcon/icons/profile-duotone.svg'
import profileMonotone from './CreditUnionIcon/icons/profile-monotone.svg'
import shipLine from './CreditUnionIcon/icons/ship-line.svg'
import shipDuotone from './CreditUnionIcon/icons/ship-duotone.svg'
import shipMonotone from './CreditUnionIcon/icons/ship-monotone.svg'
import umbrellaLine from './CreditUnionIcon/icons/umbrella-line.svg'
import umbrellaDuotone from './CreditUnionIcon/icons/umbrella-duotone.svg'
import umbrellaMonotone from './CreditUnionIcon/icons/umbrella-monotone.svg'
import unlockLine from './CreditUnionIcon/icons/unlock-line.svg'
import unlockDuotone from './CreditUnionIcon/icons/unlock-duotone.svg'
import unlockMonotone from './CreditUnionIcon/icons/unlock-monotone.svg'
import upLine from './CreditUnionIcon/icons/up-line.svg'
import upDuotone from './CreditUnionIcon/icons/up-duotone.svg'
import upMonotone from './CreditUnionIcon/icons/up-monotone.svg'
import walletLine from './CreditUnionIcon/icons/wallet-line.svg'
import walletDuotone from './CreditUnionIcon/icons/wallet-duotone.svg'
import walletMonotone from './CreditUnionIcon/icons/wallet-monotone.svg'
import wrenchLine from './CreditUnionIcon/icons/wrench-line.svg'
import wrenchDuotone from './CreditUnionIcon/icons/wrench-duotone.svg'
import wrenchMonotone from './CreditUnionIcon/icons/wrench-monotone.svg'
import faqLine from './CreditUnionIcon/icons/faq-line.svg'
import faqDuotone from './CreditUnionIcon/icons/faq-duotone.svg'
import faqMonotone from './CreditUnionIcon/icons/faq-monotone.svg'
import awardLine from './CreditUnionIcon/icons/award-line.svg'
import awardDuotone from './CreditUnionIcon/icons/award-duotone.svg'
import awardMonotone from './CreditUnionIcon/icons/award-monotone.svg'
import hardhatLine from './CreditUnionIcon/icons/hardhat-line.svg'
import hardhatDuotone from './CreditUnionIcon/icons/hardhat-duotone.svg'
import hardhatMonotone from './CreditUnionIcon/icons/hardhat-monotone.svg'
import xLine from './CreditUnionIcon/icons/x-line.svg'
import xDuotone from './CreditUnionIcon/icons/x-duotone.svg'
import xMonotone from './CreditUnionIcon/icons/x-monotone.svg'
import checkLine from './CreditUnionIcon/icons/check-line.svg'
import checkDuotone from './CreditUnionIcon/icons/check-duotone.svg'
import checkMonotone from './CreditUnionIcon/icons/check-monotone.svg'
import letterLine from './CreditUnionIcon/icons/letter-line.svg'
import letterDuotone from './CreditUnionIcon/icons/letter-duotone.svg'
import letterMonotone from './CreditUnionIcon/icons/letter-monotone.svg'
import appleLine from './CreditUnionIcon/icons/apple-line.svg'
import appleDuotone from './CreditUnionIcon/icons/apple-duotone.svg'
import appleMonotone from './CreditUnionIcon/icons/apple-monotone.svg'
import sa1Line from './CreditUnionIcon/icons/sa1-line.svg'
import sa1Duotone from './CreditUnionIcon/icons/sa1-duotone.svg'
import sa1Monotone from './CreditUnionIcon/icons/sa1-monotone.svg'
import sa2Line from './CreditUnionIcon/icons/sa2-line.svg'
import sa2Duotone from './CreditUnionIcon/icons/sa2-duotone.svg'
import sa2Monotone from './CreditUnionIcon/icons/sa2-monotone.svg'
import ribbonLine from './CreditUnionIcon/icons/ribbon-line.svg'
import ribbonDuotone from './CreditUnionIcon/icons/ribbon-duotone.svg'
import ribbonMonotone from './CreditUnionIcon/icons/ribbon-monotone.svg'
import planeLine from './CreditUnionIcon/icons/plane-line.svg'
import planeDuotone from './CreditUnionIcon/icons/plane-duotone.svg'
import planeMonotone from './CreditUnionIcon/icons/plane-monotone.svg'
import plane2Line from './CreditUnionIcon/icons/plane2-line.svg'
import plane2Duotone from './CreditUnionIcon/icons/plane2-duotone.svg'
import plane2Monotone from './CreditUnionIcon/icons/plane2-monotone.svg'
import statsLine from './CreditUnionIcon/icons/stats-line.svg'
import statsDuotone from './CreditUnionIcon/icons/stats-duotone.svg'
import statsMonotone from './CreditUnionIcon/icons/stats-monotone.svg'
import coinsLine from './CreditUnionIcon/icons/coins-line.svg'
import coinsDuotone from './CreditUnionIcon/icons/coins-duotone.svg'
import coinsMonotone from './CreditUnionIcon/icons/coins-monotone.svg'
import happyLine from './CreditUnionIcon/icons/happy-line.svg'
import happyDuotone from './CreditUnionIcon/icons/happy-duotone.svg'
import happyMonotone from './CreditUnionIcon/icons/happy-monotone.svg'
import treeLine from './CreditUnionIcon/icons/tree-line.svg'
import treeDuotone from './CreditUnionIcon/icons/tree-duotone.svg'
import treeMonotone from './CreditUnionIcon/icons/tree-monotone.svg'
import leafLine from './CreditUnionIcon/icons/leaf-line.svg'
import leafDuotone from './CreditUnionIcon/icons/leaf-duotone.svg'
import leafMonotone from './CreditUnionIcon/icons/leaf-monotone.svg'
import heartinhandLine from './CreditUnionIcon/icons/heartinhand-line.svg'
import heartinhandDuotone from './CreditUnionIcon/icons/heartinhand-duotone.svg'
import heartinhandMonotone from './CreditUnionIcon/icons/heartinhand-monotone.svg'
import digitalbankingLine from './CreditUnionIcon/icons/digitalbanking-line.svg'
import digitalbankingDuotone from './CreditUnionIcon/icons/digitalbanking-duotone.svg'
import digitalbankingMonotone from './CreditUnionIcon/icons/digitalbanking-monotone.svg'
import brokenBar from './CreditUnionIcon/icons/broken-bar.svg'

//Mapping of iconCode to Icon Function Component
type CreditUnionIconMapType = Record<string, {
  svg?: React.ComponentType<ComponentProps<SvgIconComponent>>
  img?: typeof analytics
}>

export const CreditUnionIconMap: CreditUnionIconMapType = {
  // Analytics
  'analytics-line': { img: analyticsLine },
  'analytics-duotone': { img: analyticsDuotone },
  'analytics-monotone': { img: analyticsMonotone },
  'analytics': { img: analyticsDuotone },

  // Australia
  'australia-line': { img: australiaLine },
  'australia-duotone': { img: australiaDuotone },
  'australia-monotone': { img: australiaMonotone },
  'australia': { img: australiaDuotone },

  // Blank Monitor
  'blankmonitor-line': { img: blankmonitorLine },
  'blankmonitor-duotone': { img: blankmonitorDuotone },
  'blankmonitor-monotone': { img: blankmonitorMonotone },
  'blankmonitor': { img: blankmonitorDuotone },

  // Calculator
  'calculator-line': { img: calculatorLine },
  'calculator-duotone': { img: calculatorDuotone },
  'calculator-monotone': { img: calculatorMonotone },
  'calculator': { img: calculatorDuotone },

  // Calendar
  'calendar-line': { img: calendarLine },
  'calendar-duotone': { img: calendarDuotone },
  'calendar-monotone': { img: calendarMonotone },
  'calendar': { img: calendarDuotone },

  // Car
  'car-line': { img: carLine },
  'car-duotone': { img: carDuotone },
  'car-monotone': { img: carMonotone },
  'car': { img: carDuotone },

  // Caravan
  'caravan-line': { img: caravanLine },
  'caravan-duotone': { img: caravanDuotone },
  'caravan-monotone': { img: caravanMonotone },
  'caravan': { img: caravanDuotone },

  // Card
  'visacard-line': { img: visacardLine },
  'visacard-duotone': { img: visacardDuotone },
  'visacard-monotone': { img: visacardMonotone },
  'visacard': { img: visacardDuotone },

  // Chat
  'chat-line': { img: chatLine },
  'chat-duotone': { img: chatDuotone },
  'chat-monotone': { img: chatMonotone },
  'chat': { img: chatDuotone },

  // Circle Star
  'circlestar-line': { img: circlestarLine },
  'circlestar-duotone': { img: circlestarDuotone },
  'circlestar-monotone': { img: circlestarMonotone },
  'circlestar': { img: circlestarDuotone },

  // Clock
  'clock-line': { img: clockLine },
  'clock-duotone': { img: clockDuotone },
  'clock-monotone': { img: clockMonotone },
  'clock': { img: clockDuotone },

  // Contact Us
  'contact-line': { img: contactLine },
  'contact-duotone': { img: contactDuotone },
  'contact-monotone': { img: contactMonotone },
  'contact': { img: contactDuotone },

  // Document
  'document-line': { img: documentLine },
  'document-duotone': { img: documentDuotone },
  'document-monotone': { img: documentMonotone },
  'document': { img: documentDuotone },

  // Dollar
  'dollar-line': { img: dollarLine },
  'dollar-duotone': { img: dollarDuotone },
  'dollar-monotone': { img: dollarMonotone },
  'dollar': { img: dollarDuotone },

  // Down
  'down-line': { img: downLine },
  'down-duotone': { img: downDuotone },
  'down-monotone': { img: downMonotone },
  'down': { img: downDuotone },

  // Envelope
  'envelope-line': { img: envelopeLine },
  'envelope-duotone': { img: envelopeDuotone },
  'envelope-monotone': { img: envelopeMonotone },
  'envelope': { img: envelopeDuotone },

  // Find Us
  'findus-line': { img: findusLine },
  'findus-duotone': { img: findusDuotone },
  'findus-monotone': { img: findusMonotone },
  'findus': { img: findusDuotone },

  // Mobile Location
  'mobilelocation-line': { img: mobilelocationLine },
  'mobilelocation-duotone': { img: mobilelocationDuotone },
  'mobilelocation-monotone': { img: mobilelocationMonotone },
  'mobilelocation': { img: mobilelocationDuotone },

  // Hand
  'hand-line': { img: handLine },
  'hand-duotone': { img: handDuotone },
  'hand-monotone': { img: handMonotone },
  'hand': { img: handDuotone },

  // Headphones
  'headphones-line': { img: headphonesLine },
  'headphones-duotone': { img: headphonesDuotone },
  'headphones-monotone': { img: headphonesMonotone },
  'headphones': { img: headphonesDuotone },

  // Home
  'home-line': { img: homeLine },
  'home-duotone': { img: homeDuotone },
  'home-monotone': { img: homeMonotone },
  'home': { img: homeDuotone },

  // Invest Tree
  'invest-line': { img: investLine },
  'invest-duotone': { img: investDuotone },
  'invest-monotone': { img: investMonotone },
  'invest': { img: investDuotone },

  // Lock
  'lock-line': { img: lockLine },
  'lock-duotone': { img: lockDuotone },
  'lock-monotone': { img: lockMonotone },
  'lock': { img: lockDuotone },

  // Mobile Lending
  'mobilelending-line': { img: mobilelendingLine },
  'mobilelending-duotone': { img: mobilelendingDuotone },
  'mobilelending-monotone': { img: mobilelendingMonotone },
  'mobilelending': { img: mobilelendingDuotone },

  // Money
  'money-line': { img: moneyLine },
  'money-duotone': { img: moneyDuotone },
  'money-monotone': { img: moneyMonotone },
  'money': { img: moneyDuotone },

  // Monitor
  'monitor-line': { img: monitorLine },
  'monitor-duotone': { img: monitorDuotone },
  'monitor-monotone': { img: monitorMonotone },
  'monitor': { img: monitorDuotone },

  // Shield
  'shield-line': { img: shieldLine },
  'shield-duotone': { img: shieldDuotone },
  'shield-monotone': { img: shieldMonotone },
  'shield': { img: shieldDuotone },

  // No Fees
  'freecharge-line': { img: freechargeLine },
  'freecharge-duotone': { img: freechargeDuotone },
  'freecharge-monotone': { img: freechargeMonotone },
  'freecharge': { img: freechargeDuotone },

  // Percentage
  'percentage-line': { img: percentageLine },
  'percentage-duotone': { img: percentageDuotone },
  'percentage-monotone': { img: percentageMonotone },
  'percentage': { img: percentageDuotone },

  // Piggy Bank
  'piggy-line': { img: piggyLine },
  'piggy-duotone': { img: piggyDuotone },
  'piggy-monotone': { img: piggyMonotone },
  'piggy': { img: piggyDuotone },

  // Profile
  'profile-line': { img: profileLine },
  'profile-duotone': { img: profileDuotone },
  'profile-monotone': { img: profileMonotone },
  'profile': { img: profileDuotone },

  // Ship
  'ship-line': { img: shipLine },
  'ship-duotone': { img: shipDuotone },
  'ship-monotone': { img: shipMonotone },
  'ship': { img: shipDuotone },

  // Umbrella
  'umbrella-line': { img: umbrellaLine },
  'umbrella-duotone': { img: umbrellaDuotone },
  'umbrella-monotone': { img: umbrellaMonotone },
  'umbrella': { img: umbrellaDuotone },

  // Unlock
  'unlock-line': { img: unlockLine },
  'unlock-duotone': { img: unlockDuotone },
  'unlock-monotone': { img: unlockMonotone },
  'unlock': { img: unlockDuotone },

  // Up
  'up-line': { img: upLine },
  'up-duotone': { img: upDuotone },
  'up-monotone': { img: upMonotone },
  'up': { img: upDuotone },

  // Wallet
  'wallet-line': { img: walletLine },
  'wallet-duotone': { img: walletDuotone },
  'wallet-monotone': { img: walletMonotone },
  'wallet': { img: walletDuotone },

  // Wrench
  'wrench-line': { img: wrenchLine },
  'wrench-duotone': { img: wrenchDuotone },
  'wrench-monotone': { img: wrenchMonotone },
  'wrench': { img: wrenchDuotone },

  // FAQ
  'faq-line': { img: faqLine },
  'faq-duotone': { img: faqDuotone },
  'faq-monotone': { img: faqMonotone },
  'faq': { img: faqDuotone },

  // Award
  'award-line': { img: awardLine },
  'award-duotone': { img: awardDuotone },
  'award-monotone': { img: awardMonotone },
  'award': { img: awardDuotone },

  // Hard Hat
  'hardhat-line': { img: hardhatLine },
  'hardhat-duotone': { img: hardhatDuotone },
  'hardhat-monotone': { img: hardhatMonotone },
  'hardhat': { img: hardhatDuotone },

  // X (No Icon)
  'x-line': { img: xLine },
  'x-duotone': { img: xDuotone },
  'x-monotone': { img: xMonotone },
  'x': { img: xDuotone },

  // Check Mark
  'check-line': { img: checkLine },
  'check-duotone': { img: checkDuotone },
  'check-monotone': { img: checkMonotone },
  'check': { img: checkDuotone },

  // Letter Blocks
  'letter-line': { img: letterLine },
  'letter-duotone': { img: letterDuotone },
  'letter-monotone': { img: letterMonotone },
  'letter': { img: letterDuotone },

  // Apple
  'apple-line': { img: appleLine },
  'apple-duotone': { img: appleDuotone },
  'apple-monotone': { img: appleMonotone },
  'apple': { img: appleDuotone },

  // South Australia - State
  'sa1-line': { img: sa1Line },
  'sa1-duotone': { img: sa1Duotone },
  'sa1-monotone': { img: sa1Monotone },
  'sa1': { img: sa1Duotone },

  // South Australia
  'sa2-line': { img: sa2Line },
  'sa2-duotone': { img: sa2Duotone },
  'sa2-monotone': { img: sa2Monotone },
  'sa2': { img: sa2Duotone },

  // Ribbon
  'ribbon-line': { img: ribbonLine },
  'ribbon-duotone': { img: ribbonDuotone },
  'ribbon-monotone': { img: ribbonMonotone },
  'ribbon': { img: ribbonDuotone },

  // Plane
  'plane-line': { img: planeLine },
  'plane-duotone': { img: planeDuotone },
  'plane-monotone': { img: planeMonotone },
  'plane': { img: planeDuotone },

  // Plane Top View
  'plane2-line': { img: plane2Line },
  'plane2-duotone': { img: plane2Duotone },
  'plane2-monotone': { img: plane2Monotone },
  'plane2': { img: plane2Duotone },

  // Bar Chart
  'stats-line': { img: statsLine },
  'stats-duotone': { img: statsDuotone },
  'stats-monotone': { img: statsMonotone },
  'stats': { img: statsDuotone },

  // Plant
  'coins-line': { img: coinsLine },
  'coins-duotone': { img: coinsDuotone },
  'coins-monotone': { img: coinsMonotone },
  'coins': { img: coinsDuotone },

  // Smiley Face
  'happy-line': { img: happyLine },
  'happy-duotone': { img: happyDuotone },
  'happy-monotone': { img: happyMonotone },
  'happy': { img: happyDuotone },

  // Trees
  'tree-line': { img: treeLine },
  'tree-duotone': { img: treeDuotone },
  'tree-monotone': { img: treeMonotone },
  'tree': { img: treeDuotone },

  // Leaves
  'leaf-line': { img: leafLine },
  'leaf-duotone': { img: leafDuotone },
  'leaf-monotone': { img: leafMonotone },
  'leaf': { img: leafDuotone },

  // Heart in Hand
  'heartinhand-line': { img: heartinhandLine },
  'heartinhand-duotone': { img: heartinhandDuotone },
  'heartinhand-monotone': { img: heartinhandMonotone },
  'heartinhand': { img: heartinhandDuotone },

  // Digital Banking
  'digitalbanking-line': { img: digitalbankingLine },
  'digitalbanking-duotone': { img: digitalbankingDuotone },
  'digitalbanking-monotone': { img: digitalbankingMonotone },
  'digitalbanking': { img: digitalbankingDuotone },

  'traingle': {
    svg: dynamic(() => import('./CreditUnionIcon/Triangle').then(mod => mod.Triangle)),
  },
  'trainglealt': {
    svg: dynamic(() => import('./CreditUnionIcon/Triangle').then(mod => mod.Triangle)),
  },
  'times': {
    svg: dynamic(() => import('./CreditUnionIcon/TimesIcon').then(mod => mod.TimesIcon)),
  },
  'timesalt': {
    svg: dynamic(() => import('./CreditUnionIcon/TimesIcon').then(mod => mod.TimesIcon)),
  },
  'double-traingle': {
    svg: dynamic(() => import('./CreditUnionIcon/DoubleTriangle').then(mod => mod.DoubleTriangle)),
  },
  'double-trainglealt': {
    svg: dynamic(() => import('./CreditUnionIcon/DoubleTriangle').then(mod => mod.DoubleTriangle)),
  },
  'hamburger': {
    img: brokenBar,
  }
}

export type IconCodeType = keyof typeof CreditUnionIconMap

export type CreditUnionIconProps = React.ComponentProps<IconComponent> & {
  iconCode: IconCodeType
  variant?: 'legacy' | 'line' | 'monotone' | 'dualtone'
  variant2?: boolean // Reskin variants from 2025
}

export const CreditUnionIcon: React.FC<PropsWithChildren<CreditUnionIconProps>> = ({ iconCode, variant, svg, ...props }) => {
  if (variant === 'line') {
    iconCode += '-line'
  } else if (variant === 'monotone') {
    iconCode += '-monotone'
  } else if (variant === 'dualtone') {
    iconCode += '-duotone'
  }

  const Icon = CreditUnionIconMap[iconCode]

  if (Icon?.svg && (!Icon?.img || svg)) {
    return <Icon.svg { ...props as ComponentProps<typeof Icon.svg> } />
  }

  // eslint-disable-next-line @next/next/no-img-element
  return Icon?.img ? <img src={Icon.img} alt={''} { ...props as ComponentProps<ImgIconComponent> } /> : null
}
